import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchRegistrationsReport } from "../api/fetchRegistrationsReport/fetchRegistrationsReportApi";
import {
  FetchRegistrationsReportParams,
  RegistrationsReportItem,
} from "../api/fetchRegistrationsReport/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface RegistrationsReportState {
  items: RegistrationsReportItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: RegistrationsReportState = {
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const registrationsReportSlice = createSlice({
  name: "registrationsReport",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setReport: (
      state,
      action: PayloadAction<{
        items: RegistrationsReportItem[];
        totalCount: number;
      }>,
    ) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setReport } =
  registrationsReportSlice.actions;

export const fetchRegistrationsReportAction =
  (params: FetchRegistrationsReportParams = {}): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchRegistrationsReport(params);
      dispatch(
        setReport({
          items: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch registrations report",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default registrationsReportSlice.reducer;
